export const FILTERS_MODAL_CLOSE_BUTTON_DATA_TEST_ID = 'filters-modal-close-button-data-test-id'
export const FILTERS_MODAL_APPLY_FILTERS_BUTTON_DATA_TEST_ID = 'filters-modal-apply-filters-button-data-test-id'
export const FILTERS_MODAL_CLEAR_FILTERS_BUTTON_DATA_TEST_ID = 'filters-modal-clear-filters-button-data-test-id'
